import styled from "styled-components";

export const RecipientsContainer = styled.span<{ $hasMultipleItems: boolean, $isMobile: boolean }>`
    display: inline-flex;
    align-items: center;
    justify-content: ${props => props.$isMobile ? 'flex-end' : 'flex-start'};
    width: 100%;
    overflow: hidden;
`;

export const RecipientText = styled.span<{ 
    $hasMultipleItems: boolean; 
    $isPaid: boolean; 
}>`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: ${props => props.$hasMultipleItems ? 'calc(100% - 20px)' : '100%'};
    margin-left: ${props => props.$isPaid ? '2px' : '0px'};
`;

export const RecipientEllipsis = styled.span`
    flex-shrink: 0;
`;